export default __webpack_public_path__ + "static/media/footer.2c1fcc03.png";